import { StatusPill } from "@/components/portfolio/StatusPill";
import { useLanguage } from "@/context/LanguageContext";
import type { Transaction } from "@/types";

export function TransactionTypePill({
  type,
}: {
  type: Transaction["transactionType"];
}) {
  const { language } = useLanguage();
  const isIncome = type === "INCOME";
  const label = isIncome
    ? language === "cs"
      ? "Příjem"
      : "Income"
    : language === "cs"
      ? "Výdaj"
      : "Expense";

  return (
    <StatusPill
      appearance="flat"
      tone={isIncome ? "success" : "danger"}
      className="px-2 py-0.5 text-[9px]"
    >
      {label}
    </StatusPill>
  );
}
